export default "__VITE_ASSET__BAAYHlxs__"